import { CorporateApplicationStepFiveTypes } from './types';
import CompanyOfficialBlock from './company-official';

const NewApplicationCorporateInfoStepFive = ({
  setValue,
  companyOfficial,
  applicationId,
  status,
  isEditable,
  applicationStatus,
  initialFields,
  fields,
  onSubmit: onApplicationSubmit,
  mainRepresentativeApplications,
  setDefaultFormValues,
  defaultFormValues: defaultApplicationFormValues,
  defaultQuestionnarieFormValues,
  applicationScheme,
  questionnarieFields,
  onSaveAccountsCurrencies,
  onSaveAccountsFlows,
  onSaveExpectedFundsOrigins,
}: CorporateApplicationStepFiveTypes) => (
  <CompanyOfficialBlock
    applications={companyOfficial}
    applicationId={applicationId}
    fields={fields}
    initialFields={initialFields}
    onApplicationSubmit={onApplicationSubmit}
    questionnarieFields={questionnarieFields}
    defaultQuestionnarieFormValues={defaultQuestionnarieFormValues}
    applicationScheme={applicationScheme}
    onSaveAccountsCurrencies={onSaveAccountsCurrencies}
    onSaveAccountsFlows={onSaveAccountsFlows}
    onSaveExpectedFundsOrigins={onSaveExpectedFundsOrigins}
    applicationsList={mainRepresentativeApplications}
    setValue={setValue}
    setDefaultFormValues={setDefaultFormValues}
    defaultApplicationFormValues={defaultApplicationFormValues}
    zIndex={17}
    applicationStatus={applicationStatus}
    isEditable={isEditable}
    status={status}
    isCof
  />
);

export default NewApplicationCorporateInfoStepFive;
